import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=7e4b1fc7&scoped=true"
import script from "./FileView.vue?vue&type=script&lang=js"
export * from "./FileView.vue?vue&type=script&lang=js"
import style0 from "./FileView.vue?vue&type=style&index=0&id=7e4b1fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4b1fc7",
  null
  
)

export default component.exports